import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'services/redux/configureStore';

import { type BoardTaskStatus } from '../../../../common/types/task';

export const selectCursorByStatus = (status: BoardTaskStatus) =>
  createSelector(
    (state: RootState) => state.tasksBoard.tasks.cursorByStatus[status],
    (cursor) => cursor
  );
